import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * The top of every screen: where the user is (title, optional breadcrumb and subtitle) and the
 * screen's primary action, on one baseline.
 */
@Component({
  selector: 'esn-page-header',
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  readonly title = input.required<string>();
  readonly subtitle = input<string | null>(null);
}
